<template>
    <div v-if="pgLoading" class="loadingLogo">
    <img src="/assets/img/logo/charity-logo.png" alt="children's heart logo" />
  </div>
  <div v-else class="">
    <Banner
      :background="info.image ? info.image.url : ''"
      :title="!pgLoading ? $t('app.contact_us') : ''"
      :subtitle="!pgLoading ? $t('app.contact_us') : ''"
    >
    </Banner>

    <section class="contacts-details-area pt-50 pb-50">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-xl-5 col-lg-6 col-md-6">
            <div class="get-touch-area pl-50 pr-50">
              <div
                class="section-title text-left mb-30 wow fadeInUp2 animated"
                data-wow-delay=".1s"
                :style="
                  $i18n.locale == 'en' ? 'text-align:left !important' : ''
                "
              >
                <h6>
                  <span :style="[locale == 'en' ? { left: 'auto' } : {}]"
                    ><i class="fas fa-heart"></i
                  ></span>
                  {{ $t("contact.stay_in_touch") }}
                </h6>
                <h2>{{ $t("contact.talk_to_us") }}</h2>
                <p><br /><br /><br /></p>
              </div>

              <div class="contacts d-flex align-items-center mb-30">
                <div class="contacts__icon mr-25">
                  <i class="flaticon-phone-call"></i>
                </div>
                <div class="contacts__text">
                  <h4 class="semi-02-title">{{ $t("contact.phone") }}</h4>
                  <!-- <h5 v-if="locale == 'ar'">
                                        {{ info.body2.replace(/<\/?[^>]+(>|$)/g, '').split('').reverse().join('') }}
                                    </h5> -->
                  <a :href="'tel:' + info.body2">
                    <h5 v-html="info.body2"></h5
                  ></a>
                  <!-- <h5  v-if="locale=='en'" v-html="info.body2"></h5> -->
                </div>
              </div>

              <div class="contacts d-flex align-items-center mb-30">
                <div class="contacts__icon mr-25">
                  <i class="flaticon-chat"></i>
                </div>
                <div class="contacts__text">
                  <h4 class="semi-02-title">{{ $t("contact.email") }}</h4>
                  <a :href="'mailto:' + info.body3">{{ info.body3 }}</a>
                </div>
              </div>

              <div class="contacts d-flex align-items-center mb-30">
                <div class="contacts__icon mr-25">
                  <i class="flaticon-location"></i>
                </div>
                <div class="contacts__text">
                  <h4 class="semi-02-title">{{ $t("contact.location") }}</h4>
                  <h5 v-html="info.body1"></h5>
                </div>
              </div>
            </div>
          </div>

          <div class="col-xl-7 col-lg-6 col-md-6">
            <div
              class="donar-information donation-form grey-bg2 mb-30 pr-50 pl-50"
            >
              <div
                class="section-title text-left mb-50 wow fadeInUp2 animated"
                data-wow-delay=".1s"
                :style="
                  $i18n.locale == 'en' ? 'text-align:left !important' : ''
                "
              >
                <h6>
                  <span :style="[locale == 'en' ? { left: 'auto' } : {}]">
                    <i class="fas fa-heart"></i>
                  </span>
                  {{ $t("contact.send_message") }}
                </h6>
                <h2>{{ $t("contact.talk") }}</h2>
              </div>

              <div class="main-contact-area">
                <form id="contactForm">
                  <div class="input-area mb-10">
                    <input
                      type="text"
                      class="form-control"
                      :placeholder="$t('app.name')"
                      v-model="row.name"
                    />
                  </div>

                  <div class="input-area mb-10">
                    <input
                      type="text"
                      class="form-control"
                      :placeholder="$t('app.email')"
                      v-model="row.email"
                    />
                  </div>

                  <div class="input-area mb-10">
                    <input
                      type="text"
                      class="form-control"
                      :placeholder="$t('app.mobile')"
                      v-model="row.mobile"
                    />
                  </div>

                  <div class="input-area mb-10">
                    <textarea
                      name="message"
                      id="messsage"
                      cols="30"
                      rows="10"
                      :placeholder="$t('app.body')"
                      v-model="row.body"
                    ></textarea>
                  </div>

                  <div class="input-btn">
                    <button
                      class="theme_btn theme_btn_bg large_btn"
                      type="button"
                      @click="sendMessage"
                      :disabled="btnLoading || recaptcha"
                    >
                      <div v-if="btnLoading">
                        <div class="loader loader-xs loader-center"></div>
                      </div>
                      <div v-if="!btnLoading">
                        {{ $t("app.send") }}
                        <i class="flaticon-left"></i>
                        <span></span>
                      </div>
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!--full-map-area start-->
    <section class="full-map-area">
      <div class="container-fluid pr-0 pl-0">
        <div class="row no-gutters">
          <div class="col-xl-12">
            <div class="map-area-02 map-area-03">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3482.3674093689688!2d48.103739784904235!3d29.21274568219251!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x352715fc88f755ce!2zMjnCsDEyJzQ1LjkiTiA0OMKwMDYnMDUuNiJF!5e0!3m2!1sar!2s!4v1649456278222!5m2!1sar!2s"
                width="600"
                height="450"
                style="border: 0"
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import iziToast from "izitoast";

export default {
  name: "List",
  components: {
    Banner: () => import("@/components/Banner.vue"),
  },
  data() {
    return {
      //
      auth: {
        access_token: "",
      },
      row: {
        name: "",
        email: "",
        mobile: "",
        subject: "",
        body: "",
      },

      locale: "ar",
      info: "",
      pgLoading: true,
      btnLoading: false,

      sitekey: "6Lc4S6wUAAAAACQyW8zgRI7swPLCtOF-AXTdKNe9",
      recaptcha: false,
    };
  },
  mounted() {},
  created() {
    //
    if (localStorage.getItem("locale")) {
      this.locale = localStorage.getItem("locale");
    }

    if (localStorage.getItem("access_token")) {
      this.auth.access_token = localStorage.getItem("access_token");
      this.row.name =
        localStorage.getItem("first_name") +
        " " +
        localStorage.getItem("last_name");
      this.row.email = localStorage.getItem("email");
      this.row.mobile = localStorage.getItem("mobile");
    }

    this.fetchData();
  },
  methods: {
    //
    fetchData() {
      window.scrollTo(0, 0);
      this.pgLoading = true;
      this.axios.defaults.headers.common = {
        "X-Requested-With": "XMLHttpRequest", // security to prevent CSRF attacks
      };
      const options = {
        url: window.baseURL + "/settings/19",
        method: "GET",
        data: {},
        params: {
          locale: this.locale,
        },
      };
      this.$axios(options)
        .then((res) => {
          this.pgLoading = false;
          this.info = res.data.info;
        })
        .catch(() => {})
        .finally(() => {});
    },

    sendMessage() {
      if (
        !this.row.name ||
        !this.row.mobile ||
        !this.row.email ||
        !this.row.body
      ) {
        alert(this.$t("app.allRequired"));
        return;
      }
      this.btnLoading = true;
      this.axios.defaults.headers.common = {
        "X-Requested-With": "XMLHttpRequest", // security to prevent CSRF attacks
      };
      const options = {
        url: window.baseURL + "/contacts",
        method: "POST",
        data: {
          name: this.row.name,
          email: this.row.email,
          mobile: this.row.mobile,
          subject: this.row.body,
          body: this.row.body,
        },
      };
      this.$axios(options)
        .then(() => {
          this.btnLoading = false;
          this.clearRow();

          iziToast.success({
            icon: "ti-check",
            title: "  ",
            message: this.$t("app.send_msg"),
          });
        })
        .catch((err) => {
          this.btnLoading = false;
          let errmsg = err.response.data.message;

          if (errmsg == "The name field is required.") {
            errmsg = "va_name";
          } else if (errmsg == "The email field is required.") {
            errmsg = "va_email";
          } else if (errmsg == "The mobile field is required.") {
            errmsg = "va_mobile";
          } else if (errmsg == "The subject field is required.") {
            errmsg = "va_subject";
          } else if (errmsg == "The body field is required.") {
            errmsg = "va_subject";
          } else {
            errmsg = "error_contact_us";
          }

          console.log(err.response.data.message);
          iziToast.warning({
            icon: "ti-alert",
            title: "",
            message: err.response ? this.$t("app." + errmsg) : "" + err,
          });
        })
        .finally(() => {});
    },

    clearRow() {
      // this.row.name = '';
      // this.row.email = '';
      // this.row.mobile = '';
      this.row.subject = "";
      this.row.body = "";
    },

    onVerify: function () {
      this.recaptcha = false;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.btn-size {
  cursor: pointer;
  height: 50px;
}
</style>
